<div class="cg-main-page-container" *ngrxLet="routeData$ as routeData">
  <header role="banner">
    <cigna-header
      [logoLink]="logoLink$ | async"
      [isLogoLinkInternal]="(isResourcePage$ | async) === false"
      [isAuthenticated]="false"
      [isNavigationDisabled]="
        routeData.disableNavigation || (siteDownFlag$ | async)
      "
    ></cigna-header>
  </header>

  <main role="main">
    <ng-container *ngIf="siteDownFlag$ | async; else mainPage">
      <cigna-unavailable [shouldShowRefreshBtn]="false"></cigna-unavailable>
    </ng-container>
    <ng-template #mainPage> <router-outlet></router-outlet></ng-template>
  </main>

  <footer role="contentinfo">
    <cigna-footer-global
      *ngIf="!routeData.disableNavigation"
      [hasOneTrustEnabled]="hasOneTrustEnabled$ | async"
    ></cigna-footer-global>
  </footer>
</div>
